import React, { useState, useEffect } from "react";
import Axios from "axios";

const CommentSection = (props) => {
  const [commentsArray, setCommentsArray] = useState([]);
  const addComment = () => {
    let comment = document.getElementById("comment-textarea").value;
    Axios.post("https://fitness-junction-bots.onrender.com/api/saveComment", {
      postId: props.postId,
      comment: comment,
    })
      .then((data) => {
        let p = document.createElement("p");
        p.innerText = comment;
        document.getElementById("comments-container").append(p);
      })
      .catch((error) => console.log(error));
  };
  const onPressEnter = (event) => {
    if (event.keyCode === 13) addComment();
  };
  useEffect(() => {
    Axios.get(
      "https://fitness-junction-bots.onrender.com/api/getComments/" +
        props.postId
    )
      .then((data) => setCommentsArray(data.data.comments))
      .catch((error) => console.log(error));
  }, []);

  return (
    <div className="container mt-4">
      <div className="row">
        <div className="col-md-12">
          <div className="mb-3">
            <textarea
              className="form-control"
              id="comment-textarea"
              placeholder="Add comment here"
              onKeyDown={onPressEnter}
            ></textarea>
          </div>
          <button type="button" className="btn bot-btn" onClick={addComment}>
            Add
          </button>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-md-12">
          <div id="comments-container">
            <h4>Comments :</h4>
            {commentsArray.map((commentObj, index) => (
              <p key={index} className="mb-0">
                {commentObj.comments}
              </p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommentSection;
